<template>
  <div id="dashboard">
    <section id="search">
      <b-field class="width-100" grouped group-multiline>
        <b-field class="no-margin__bottom" label-position="on-border" label="Search Criteria">
          <b-select expanded v-model="searchCriteria" name="searchCriteria" id="searchCriteria">
            <option class="dropdown-item" value="Booking Id">Booking Id</option>
            <option class="dropdown-item" value="Booking Date">Booking Date</option>
            <option class="dropdown-item" value="Booking Reference">Booking Reference</option>
            <option class="dropdown-item" value="Supplier Reference">Supplier Reference</option>
            <option class="dropdown-item" value="Payer Name">Payer Name</option>
            <option class="dropdown-item" value="Email">Email</option>
            <option class="dropdown-item" value="Mobile Number">Mobile Number</option>
            <option class="dropdown-item" value="Pickup Time">Pickup Time</option>
            <option class="dropdown-item" value="Dropoff Time">Dropoff Time</option>
          </b-select>
        </b-field>
        <b-field class="no-margin__bottom" label-position="on-border" label="Rows">
          <b-select expanded v-model="numRows" name="numRows" id="numRows">
            <option class="dropdown-item" value="10">10</option>
            <option class="dropdown-item" value="20">20</option>
            <option class="dropdown-item" value="50">50</option>
          </b-select>
        </b-field>
        <b-field class="no-margin__bottom" label-position="on-border" label="Search..." expanded>
          <b-input
            expanded
            :title="searchCriteria == 'Booking Date' ? 'Date Format: yyyy-mm-dd hh:mm:ss' : 'Date Format: dd/mm/yyyy hh:mm'"
            v-on:keyup.enter="searchDatabase()"
            class="search"
            v-model="searchData"
          ></b-input>
        </b-field>
        <b-field class="search-button">
          <b-button type="is-info" @click="searchDatabase()" class="search-button-content">
            <b-icon class="button-icon" size="is-small" pack="fas" icon="search"></b-icon>
          </b-button>
        </b-field>
        <b-field class="width-100 margin-bottom" grouped>
          <b-checkbox v-model="status" native-value="All">All</b-checkbox>
          <b-checkbox v-model="status" native-value="Confirmed">Confirmed</b-checkbox>
          <b-checkbox v-model="status" native-value="Pending">Pending</b-checkbox>
          <b-checkbox v-model="status" native-value="Failed">Failed</b-checkbox>
        </b-field>
      </b-field>
    </section>

    <section id="results">
      <b-table
        :data="filteredResults"
        ref="table"
        detailed
        :striped="true"
        :hoverable="true"
        detail-key="booking_id"
        :per-page="this.numRows"
        :opened-detailed="defaultOpenedDetails"
      >
        <template slot-scope="props">
          <b-table-column field="id" label="Booking Id" sortable>
            <template>{{ props.row.booking_id }}</template>
          </b-table-column>
          <b-table-column field="name" label="Name" sortable centered>
            <span class="tag">{{ props.row.first_name + " " + props.row.last_name }}</span>
          </b-table-column>
          <b-table-column field="mobile" label="Mobile" sortable centered>
            <span class="tag">{{ props.row.mobile }}</span>
          </b-table-column>
          <b-table-column field="email" label="Email" sortable centered>
            <span class="tag">{{ props.row.email }}</span>
          </b-table-column>
          <b-table-column field="booking_date" label="Booking Date" sortable centered>
            <span class="tag">{{ props.row.booking_date }}</span>
          </b-table-column>
          <b-table-column field="pickup" label="Pickup Date" sortable centered>
            <span class="tag">{{ props.row.pickup_time }}</span>
          </b-table-column>
          <b-table-column field="dropoff" label="Dropoff Date" sortable centered>
            <span class="tag">{{ props.row.dropoff_time }}</span>
          </b-table-column>
          <b-table-column field="bookingRef" label="Booking Reference" sortable centered>
            <span class="tag">{{ props.row.bookingReference }}</span>
          </b-table-column>
          <b-table-column field="supplierRef" label="Supplier Reference" sortable centered>
            <span class="tag">{{ props.row.supplierBookingReference }}</span>
          </b-table-column>
          <b-table-column field="price" label="Price" sortable centered>
            <span class="tag">R{{ props.row.price }}</span>
          </b-table-column>
          <b-table-column field="status" label="Status" sortable centered>
            <span
              class="tag"
              :class="statusClass(props.row.booking_status)"
            >{{ props.row.booking_status }}</span>
          </b-table-column>
        </template>
        <template slot="detail" slot-scope="props">
          <div class="inner-content-row">
            <div class="inner-content">
              <span>Group</span>
              <span class="tag">{{ props.row.group_key }}</span>
            </div>
            <div class="inner-content">
              <span>Car</span>
              <span class="tag">{{ props.row.name }}</span>
            </div>
            <div class="inner-content">
              <span>Seats</span>
              <span class="tag">{{ props.row.seats }}</span>
            </div>
            <div class="inner-content">
              <span>Doors</span>
              <span class="tag">{{ props.row.doors }}</span>
            </div>
            <div class="inner-content">
              <span>Airbags</span>
              <span class="tag">{{ props.row.has_airbag ? 'yes' : 'false' }}</span>
            </div>
            <div class="inner-content">
              <span>Aircon</span>
              <span class="tag">{{ props.row.has_aircon ? 'yes' : 'false' }}</span>
            </div>
            <div class="inner-content">
              <span>Pickup Location</span>
              <span class="tag">{{ findLocation(props.row.pickup_location) }}</span>
            </div>
            <div class="inner-content">
              <span>Dropoff Location</span>
              <span class="tag">{{ findLocation(props.row.dropoff_location) }}</span>
            </div>
          </div>
        </template>
      </b-table>
    </section>
  </div>
</template>

<script>
import Vue from "vue";
import Api from "@/services/Api.service.js";
import { findByLocationId } from "@/services/Location.service.js";

export default {
  name: "Dashboard",
  data() {
    return {
      searchCriteria: "transactionID",
      searchData: "",
      numRows: 10,
      loading: false,
      results: [],
      filteredResults: [],
      status: ["All"],
      defaultOpenedDetails: [1]
    };
  },
  methods: {
    findByLocationId: findByLocationId,
    findLocation(id) {
      let temp = findByLocationId(id);
      return temp[0].locationName;
    },
    makeInnerObj(thing) {
      return Object.entries(thing).map(key => {
        return { [key[0]]: key[1] };
      });
    },
    statusClass(status) {
      switch (status.toLowerCase()) {
        case "confirmed":
          return "is-success";
        case "failed":
          return "is-danger";
        case "pending":
          return "is-warning";
        default:
          break;
      }
    },
    searchDatabase() {
      Api.post("dashboard/FetchBookings.php", {
        numRows: this.numRows,
        searchCriteria: this.searchCriteria,
        searchData: this.searchData
      }).then(
        result => {
          this.results = result.data.response;
          this.filteredResults = this.results;
          this.statusWatch(this.status);
        },
        error => {
          console.error(error);
        }
      );
    },
    statusWatch(newVal) {
      this.filteredResults = [];
      if (newVal.includes("All")) {
        this.filteredResults = this.results;
      } else {
        let context = this;
        this.status.forEach(function(status) {
          context.filteredResults.push(
            ...context.results.filter(result => {
              if (result.booking_status == status.toUpperCase()) {
                return true;
              }
            })
          );
        });
      }
    }
  },
  mounted() {
    Api.get("dashboard/FetchBookings.php").then(
      result => {
        this.results = result.data.response;
        this.filteredResults = this.results;
      },
      error => {
        console.error(error);
      }
    );
  },
  watch: {
    status: function(newVal) {
      this.filteredResults = [];
      if (newVal.includes("All")) {
        this.filteredResults = this.results;
      } else {
        let context = this;
        this.status.forEach(function(status) {
          context.filteredResults.push(
            ...context.results.filter(result => {
              if (result.booking_status == status.toUpperCase()) {
                return true;
              }
            })
          );
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/settings.scss";
// @import '~bulma/sass/utilities/_all.sass';
// @import '~bulma/bulma';
// @import '~buefy/dist/buefy.css';

#search {
  background: $grey;
  max-width: 720px;
  margin: 100px auto 25px auto;
  padding: $standard-padding;
  border-radius: 8px;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  box-shadow: 0 1px 6px rgba(32, 33, 36, 0.28);
}

#results {
  background: $grey;
  margin: 25px auto;
  padding: $standard-padding;
  border-radius: 8px;
  text-align: left;
  display: flex;
  width: fit-content;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  box-shadow: 0 1px 6px rgba(32, 33, 36, 0.28);
}

.no-margin__bottom {
  margin-bottom: 0 !important;
}

.margin-bottom {
  margin-bottom: $standard-padding;
}

.width-100 {
  width: 100%;
}

.inner-content {
  width: min-content;
  align-items: center;
  display: flex;
  flex-direction: column;
}

.inner-content-row {
  display: flex;
  width: 100%;
  justify-content: space-evenly;
}
</style>
